module.exports = __webpack_public_path__ + "img/openagent-mark-white.3096ef92.svg";